import Col from "antd/lib/col"
import Form from "antd/lib/form"
import React from "react"
import DatePicker from "antd/lib/date-picker"
import moment from "moment"
import { FormInputElementInterface } from "./form.types"
import { getPopupAnchor } from "Shared/utils/popup.utils"

interface FormInputInterface {
    elem: FormInputElementInterface
    span?: number
    className?: string
    pickerClassName?: string
    hideLabel?: boolean
    anchorRef: any
}

export default function FormInputDate({ elem, span, anchorRef, className = "", pickerClassName = "", hideLabel = false }: FormInputInterface) {
    return (
        <Col span={span ? span : 12}>
            <Form.Item
                label={!hideLabel ? elem.label : undefined}
                name={elem.name}
                style={{ marginBottom: "0px" }}
                initialValue={elem.initialValue ? moment(elem.initialValue) : ""}
                rules={elem.rules}
                className={`mb-0 ${className}`}
            >
                <DatePicker
                    style={{ width: "100%" }}
                    format={moment.localeData().longDateFormat("l")}
                    placeholder={elem.placeholder}
                    onChange={elem.onChange}
                    className={pickerClassName}
                    getPopupContainer={getPopupAnchor(anchorRef.current)}
                />
            </Form.Item>
        </Col>
    )
}
